import React from "react";
import BlogSix from "../component/BlogSix";

function BlogSixContainer() {
  return <BlogSix />;
}
export default BlogSixContainer;
